const Locations = {
  locationsPath: () => 'ExternalSale/GetLocations',
};

export default Locations;
